import { useState } from 'react';

import { ReactSelectOption } from '@models/common/ReactSelectOption';
import { SalesTaxService } from '@services/SalesTax';

const initialSalesTaxes: ReactSelectOption[] = [];

export const useSalesTaxSelectOptions = () => {
  const [salesTaxSelectOptions, setSalesTaxSelectOptions] =
    useState<ReactSelectOption[]>(initialSalesTaxes);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSuccess, setIsSuccess] = useState<boolean>(false);
  const [errorMessages, setErrorMessages] = useState<string[] | undefined>([]);

  const loadData = async () => {
    setIsLoading(true);
    const result = await SalesTaxService.getSalesTaxSelectOptions();

    if (result.isSuccess && 'data' in result) {
      const options = [{ value: '0', label: '' }].concat(
        result.data.map((row) => ({
          value: row.value,
          label: row.text,
        }))
      );
      setSalesTaxSelectOptions(options);
      setIsLoading(false);
      setIsSuccess(true);
      console.log('Success: Fetched the record.');
    } else {
      console.error('Error: Failed to get record.', result.errorMessages);
      setIsSuccess(false);
      setErrorMessages(result.errorMessages);
    }
  };

  return {
    salesTaxSelectOptions,
    isLoading,
    isSuccess,
    errorMessages,
    loadData,
  };
};
